import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c(VCard,[_c(VCardTitle,{staticClass:"titulopagina"},[_vm._v("ADMINISTRAR ESTANQUES DE ACEITE EXTERNOS")]),_c(VCardText,[_c(VBtn,{attrs:{"color":"green","fab":"","small":"","dark":""},on:{"click":_vm.crear}},[_c(VIcon,[_vm._v("add")])],1)],1)],1),_c('data-table',{staticClass:"mt-5",on:{"editar":function($event){return _vm.editar($event)}}}),_c('modal',{on:{"peticionrealizada":_vm.cargarDatos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }